import { render, staticRenderFns } from "./WildHearts.vue?vue&type=template&id=fb8d0a34&lang=pug&"
import script from "./WildHearts.vue?vue&type=script&lang=js&"
export * from "./WildHearts.vue?vue&type=script&lang=js&"
import style0 from "@/assets/themes/ea-wild-hearts/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports